import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of method-specific config blocks (D17 number,
// bank details) based on the matching method checkbox in the workspace
// payment settings form. Keeps both client-side rendering and the
// initial server-rendered `hidden` state in sync.
export default class extends Controller {
  static targets = ["d17Toggle", "d17Config", "bankToggle", "bankConfig"]

  connect() {
    this.update()
  }

  update() {
    // Sans patente validée, les cases D17 et virement ne sont plus rendues
    // (27/09/2026) : lire la cible absente lèverait une erreur.
    if (this.hasD17ConfigTarget) {
      this.d17ConfigTarget.hidden = !(this.hasD17ToggleTarget && this.isChecked(this.d17ToggleTarget))
    }
    if (this.hasBankConfigTarget) {
      this.bankConfigTarget.hidden = !(this.hasBankToggleTarget && this.isChecked(this.bankToggleTarget))
    }
  }

  isChecked(el) {
    return el && el.checked
  }
}
